/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const findCertificatesByOrganizationIdRequestFiltersDtoExpiringCertificatesEnum =
  {
    expiring: "expiring",
    all: "all",
  } as const

export type FindCertificatesByOrganizationIdRequestFiltersDtoExpiringCertificatesEnumKey =
  (typeof findCertificatesByOrganizationIdRequestFiltersDtoExpiringCertificatesEnum)[keyof typeof findCertificatesByOrganizationIdRequestFiltersDtoExpiringCertificatesEnum]

export const findCertificatesByOrganizationIdRequestFiltersDtoCategoryEnum = {
  TRANSACTION: "TRANSACTION",
  SCOPE: "SCOPE",
  OTHER_INITIATIVES: "OTHER_INITIATIVES",
  UNKNOWN: "UNKNOWN",
} as const

export type FindCertificatesByOrganizationIdRequestFiltersDtoCategoryEnumKey =
  (typeof findCertificatesByOrganizationIdRequestFiltersDtoCategoryEnum)[keyof typeof findCertificatesByOrganizationIdRequestFiltersDtoCategoryEnum]

export const findCertificatesByOrganizationIdRequestFiltersDtoStatusEnum = {
  NOT_UPLOADED: "NOT_UPLOADED",
  PENDING: "PENDING",
  PROCESSED: "PROCESSED",
  REJECTED: "REJECTED",
} as const

export type FindCertificatesByOrganizationIdRequestFiltersDtoStatusEnumKey =
  (typeof findCertificatesByOrganizationIdRequestFiltersDtoStatusEnum)[keyof typeof findCertificatesByOrganizationIdRequestFiltersDtoStatusEnum]

export const findCertificatesByOrganizationIdRequestFiltersDtoCertificateRequestStatusEnum =
  {
    OPENED: "OPENED",
    SUBMITTED: "SUBMITTED",
    REJECTED: "REJECTED",
    ACCEPTED: "ACCEPTED",
    CANCELED: "CANCELED",
  } as const

export type FindCertificatesByOrganizationIdRequestFiltersDtoCertificateRequestStatusEnumKey =
  (typeof findCertificatesByOrganizationIdRequestFiltersDtoCertificateRequestStatusEnum)[keyof typeof findCertificatesByOrganizationIdRequestFiltersDtoCertificateRequestStatusEnum]

export type FindCertificatesByOrganizationIdRequestFiltersDto = {
  /**
   * @type string | undefined
   */
  expiringCertificates?: FindCertificatesByOrganizationIdRequestFiltersDtoExpiringCertificatesEnumKey
  /**
   * @type string | undefined
   */
  category?: FindCertificatesByOrganizationIdRequestFiltersDtoCategoryEnumKey
  /**
   * @type string | undefined
   */
  certificateTypeId?: string
  /**
   * @type string | undefined
   */
  status?: FindCertificatesByOrganizationIdRequestFiltersDtoStatusEnumKey
  /**
   * @type string | undefined
   */
  certificateRequestStatus?: FindCertificatesByOrganizationIdRequestFiltersDtoCertificateRequestStatusEnumKey
  /**
   * @type string | undefined
   */
  score?: string
  /**
   * @type array | undefined
   */
  issueDate?: string[]
  /**
   * @type array | undefined
   */
  expiryDate?: string[]
  /**
   * @type string | undefined
   */
  productionSiteId?: string
  /**
   * @type string | undefined
   */
  businessPartnerId?: string
  /**
   * @type string | undefined
   */
  createdAt?: string
  /**
   * @type array | undefined
   */
  productPurchaseOrderReferences?: string[]
  /**
   * @type array | undefined
   */
  materialPurchaseOrderReferences?: string[]
  /**
   * @type array | undefined
   */
  componentPurchaseOrderReferences?: string[]
}
